import { FC, MouseEventHandler } from 'react';
import classNames from 'classnames';
import { BackButton } from '../../Buttons';

export interface StepsIndicatorProps {
  className?: string;
  steps:
    | number
    | Array<{
        key: string;
        hidden?: boolean;
        showActive?: number;
      }>;
  activeStep?: number | string;
  onBackClick?: MouseEventHandler;
}

export const StepsIndicator: FC<StepsIndicatorProps> = ({ className, steps, activeStep, onBackClick }) => {
  if (!steps) return null;

  const items = typeof steps === 'number' ? Array.from(Array(steps)) : steps;
  const itemCount = items.filter(item => !item.hidden).length;
  const currentStep = items.find(s => s.key === activeStep);

  return (
    <div className={classNames('steps-indicator relative flex items-center', className)}>
      {currentStep?.hasBackButton && <BackButton onClick={onBackClick} aria-label="Go to previous step" />}

      <ol className="flex gap-2 sm:gap-4 w-full items-center px-16">
        {items.map((item, index) => {
          const activeIndex =
            (typeof activeStep === 'string' ? items.findIndex(step => step.key === activeStep) : activeStep) || 0;

          const isActive = index === activeIndex || index === currentStep?.showActive;
          const isComplete = index < activeIndex && index !== currentStep?.showActive;
          const isIncomplete = index > activeIndex && index !== currentStep?.showActive;

          if (item.hidden) return null;

          return (
            <li
              key={item?.key || index}
              style={{ flexGrow: isActive ? itemCount / 2 : 1 }}
              className={classNames(`steps-indicator__step z-10 h-1 rounded-sm transition-all`, {
                'steps-indicator__step--active bg-brand-300': isActive,
                'steps-indicator__step--complete bg-brand': isComplete,
                'steps-indicator__step--incomplete bg-background-darker': isIncomplete
              })}
            />
          );
        })}
      </ol>
    </div>
  );
};
